@if (canStartActivity) {
  <button mat-menu-item (click)="onStartActivity.emit()" class="start-activity-btn">{{'session-zero-state_start-activity' | translate}}</button>
}
@if (hasMenuAccess()) {
  <button mat-menu-item (click)="editActivity()" class="edit-activity-btn">{{'activity-list_activity-options-menu-edit-activity' | translate}}</button>
}
@if (hasMenuAccess() && !isLti()) {
  <button mat-menu-item (click)="manageUsers()" class="manage-users-btn">{{'course-menu_manage-users' | translate}}</button>
}
@if (hasMenuAccess() && !isLti()) {
  <button mat-menu-item (click)="openInviteModal()" class="invite-btn">{{'common_invite' | translate}}</button>
}
@if (canViewInstruction()) {
  <button mat-menu-item (click)="viewInstructions.emit()" class="view-instruction-btn">{{'session-zero-state_view_instructions' | translate}}</button>
}
